import $ from 'jquery';

export default ({
  countContainerSelector, counterSelector, inputSelector, noCharactersLeftClass,
}) => {
  const $input = $(inputSelector);
  const $container = $(countContainerSelector);
  const $counter = $(counterSelector);
  const maxLength = parseInt($input.attr('maxlength'), 10);

  const onInput = () => {
    const charactersLeft = maxLength - $input.val().length;

    $counter.text(charactersLeft);
    $container.removeClass(noCharactersLeftClass);

    if (charactersLeft === 0) {
      $container.addClass(noCharactersLeftClass);
    }
  };

  $(inputSelector).on('input', onInput);
};
